module.exports = __webpack_public_path__ + "media/images/refresh-icon-2fc7653ffaf35f78616b32b0f672a85d.svg";